import type { LoginResponse } from '@lista/shared-validation';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { authService } from '../api';
import { setLocale } from '../../i18n';
import { clearApiCaches } from '../pwa/cache';
import { useSession } from './session-store';

export function useAuthActions() {
  const queryClient = useQueryClient();

  const completeLogin = useCallback((session: LoginResponse) => {
    useSession.getState().signIn(session.accessToken, session.user);
    if (session.user.locale === 'ar' || session.user.locale === 'en')
      setLocale(session.user.locale);
  }, []);

  const signOut = useCallback(
    async (everywhere = false) => {
      try {
        await (everywhere ? authService.logoutAll() : authService.logout());
      } catch {
        // Signing out locally must work even if the request fails (offline, expired session).
      }
      useSession.getState().signOut();
      queryClient.clear();
      await clearApiCaches();
    },
    [queryClient],
  );

  return { completeLogin, signOut };
}
